'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  border: 0;\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  ',
    ';\n'
  ],
  [
    '\n  border: 0;\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  ',
    ';\n'
  ]
)

var _styledSystem = require('styled-system')

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Divider = _Box2.default
  .withComponent('hr')
  .extend(_templateObject, _styledSystem.borderColor)

Divider.displayName = 'Divider'

Divider.defaultProps = {
  borderColor: 'smoke',
  mx: 0
}

Divider.propTypes = _extends({}, _styledSystem.propTypes.borderColor)

exports.default = Divider



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Divider.js
// module id = 44
// module chunks = 35783957827783 95570949031736 114276838955818 162898551421021